import React from 'react';
import PreFormGiftcardProblems from '../../../../../common/PreFormGiftcardProblems';
import { useLocation } from 'react-router-dom';

const ProblemsGiftcardMobile = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const motiveId = params.get('motiveId');

  return (
    <PreFormGiftcardProblems
      mobile
      motiveId={motiveId}
      issueForm={'problemsGiftcard'}
    />
  );
};

export default ProblemsGiftcardMobile;
